import { Sheet } from "@mui/joy";
import styled from "styled-components";
import { useTheme } from "@mui/joy";

const Subtitle = styled.h2`
  margin: 1% 0;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "1vw" : "3vw")};
  white-space: nowrap;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
`;

const TechMainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin: 0 auto 2% auto;
  width: 100%;
`;

const Headline = styled.h1`
  margin: 1% 0;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "1.1vw" : "3.5vw")};
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  white-space: nowrap;
`;

const JobType = styled(Subtitle)`
  border-radius: 10px;
  padding: 3%;
  background-color: ${(props) => props.theme.palette.background.level3};
  width: max-content;
  color: ${(props) => props.theme.palette.text.primary};
`;

const TechChildContainer = styled.img`
  display: flex;
  width: auto;
  height: auto;
  padding-top: 2%;
  max-width: 40%;
  max-height: 6vh;
  border-radius: 5%;
`;

const Hello = styled.h1`
  margin: 1% 0 1% 2%;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "2.5vw" : "5vw")};
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  white-space: nowrap;
`;

const DescriptionContainer = styled.div`
  margin: 3% auto 3% auto;
  display: flex;
  flex-direction: column;
`;

const Description = styled.p`
  margin: 1% 5%;
`;

const ImageCompanyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const CompanyImage = styled.img`
  display: flex;
  width: auto;
  height: auto;
  padding-top: 2%;
  max-width: 40%;
  max-height: 6vh;
  margin-right: 5%;
  margin-left: 2%;
`;

const ExpContainer = styled.div`
  border-radius: 15;
  padding: 2;
  margin: auto;
  margin-top: 2;
  width: 100%;
  max-height: 150vh;
  display: flex;
  justify-content: space-evenly;
  flex-direction: ${(props) => (props.size.width >= 800 ? "row" : "column")};
  flex-wrap: wrap;
`;

const Experience = (props) => {
  const theme = useTheme();
  console.log(theme);

  const assets = props.exp.assets;

  var mode = localStorage.getItem("joy-mode");

  const dynamicWidth = () => {
    if (props.size.width >= 900) {
      return (props.size.width * 3) / 5;
    } else if (props.size.width >= 600) {
      return (props.size.width * 4) / 5;
    } else {
      return (props.size.width * 6) / 7;
    }
  };

  const childContainer = {
    padding: "2%",
    borderRadius: "15px",
    marginTop: "3%",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
    width: props.size.width >= 800 ? "42%" : "95%",
    boxShadow:
      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
    backgroundColor: theme.palette.background.level1,
    height: "35vh",
  };

  const mainContainer = {
    borderRadius: 15,
    padding: 2,
    margin: "auto",
    marginTop: 2,
    width: dynamicWidth(),
    display: "flex",
    justifyContent: "space-between",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px;",
    flexDirection: "column",
  };

  const ExpObj = (exp, keyval) => {
    var descr = [];

    exp.description.forEach((element) => {
      descr.push(<Description key={element.length}>{element}</Description>);
    });

    var techs = [];
    exp.technologies.forEach((lang) => {
      techs.push(
        <TechChildContainer
          key={assets[lang.toLowerCase()]}
          src={assets[lang.toLowerCase()]}
        />
      );
    });

    var image = exp.image;

    if (mode === "dark" && exp.image_dark) {
      image = exp.image_dark;
    }

    return (
      <Sheet sx={childContainer} key={keyval}>
        <ImageCompanyContainer>
          <CompanyImage src={image} />
          <CompanyInfo>
            <Headline size={props.size}>{exp.title}</Headline>
            <JobType size={props.size} theme={theme}>
              {exp.type}
            </JobType>
          </CompanyInfo>
        </ImageCompanyContainer>
        <DescriptionContainer>{descr}</DescriptionContainer>
        <TechMainContainer>{techs}</TechMainContainer>
      </Sheet>
    );
  };

  const exps = [];
  for (let i = 0; i < props.exp.jobs.length; i++) {
    exps.push(ExpObj(props.exp.jobs[i], i));
  }

  return (
    <div id={props.id}>
      <Sheet sx={mainContainer}>
        <Hello size={props.size}>Experience</Hello>
        <ExpContainer size={props.size}>{exps}</ExpContainer>
      </Sheet>
    </div>
  );
};

export default Experience;
